import { TaskDashboardResponse } from '@urbanx/agx.activities.client';
import { AgxMetric, AgxProgressChart, AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { TasksSearchFilterType } from '../TasksModal/TasksSearchFilterType';

interface TodaysTaskStatsProps {
  dashboardStats?: TaskDashboardResponse;
  onStatTypeSelected: (_filterType: TasksSearchFilterType) => void;
}

const TodaysTaskStats = ({ dashboardStats, onStatTypeSelected }: TodaysTaskStatsProps) => {
  const {
    numberOfLaunchesDueToday,
    numberOfDepositsDueToday,
    numberOfConditionsDueToday,
    numberOfSettlementsDueToday,
    numberOfTerminationsDueToday,
    numberOfOverdueTasks,
    numberOfTasksDueAndCompletedToday,
    numberOfIncompleteTasksDueToday,
  } = dashboardStats || {};

  const totalNumberOfTasksDueToday =
    (numberOfTasksDueAndCompletedToday ?? 0) + (numberOfIncompleteTasksDueToday ?? 0);

  return (
    <AgxSpacer direction="vertical" gap="sm" style={{ paddingTop: 'var(--padding-md)' }}>
      <AgxTypography
        id="todays-tasks-stats-header"
        type="body_ui_strong"
        size="medium"
        color="var(--text-primary)"
      >
        Due Today
      </AgxTypography>
      <div
        className="todays-task-stats-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 'var(--gap-2xs)',
        }}
      >
        <AgxMetric
          title={'Launches'}
          metric={numberOfLaunchesDueToday ?? '--'}
          action={{
            label: 'View tasks',
            onClick: () => onStatTypeSelected(TasksSearchFilterType.Launches),
          }}
        />
        <AgxMetric
          title={'Deposits'}
          metric={numberOfDepositsDueToday ?? '--'}
          action={{
            label: 'View tasks',
            onClick: () => onStatTypeSelected(TasksSearchFilterType.Deposits),
          }}
        />
        <AgxMetric
          title={'Conditions'}
          metric={numberOfConditionsDueToday ?? '--'}
          action={{
            label: 'View tasks',
            onClick: () => onStatTypeSelected(TasksSearchFilterType.Conditions),
          }}
        />
        <AgxMetric
          title={'Settlements'}
          metric={numberOfSettlementsDueToday ?? '--'}
          action={{
            label: 'View tasks',
            onClick: () => onStatTypeSelected(TasksSearchFilterType.Settlements),
          }}
        />
        <AgxMetric
          title={'Terminations'}
          metric={numberOfTerminationsDueToday ?? '--'}
          action={{
            label: 'View tasks',
            onClick: () => onStatTypeSelected(TasksSearchFilterType.Terminations),
          }}
        />
        <AgxMetric
          title={'Overdue'}
          metric={numberOfOverdueTasks ?? '--'}
          action={{
            label: 'View tasks',
            onClick: () => onStatTypeSelected(TasksSearchFilterType.Overdue),
          }}
        />
        <AgxProgressChart
          id={'todays-tasks-progress-chart'}
          title={"Today's Progress"}
          currentMetric={numberOfTasksDueAndCompletedToday ?? 0}
          totalMetric={totalNumberOfTasksDueToday}
          metricLabel={'tasks completed'}
          style={{
            gridColumn: '4',
            gridRow: '1/3',
          }}
        />
      </div>
    </AgxSpacer>
  );
};

export default TodaysTaskStats;
